// src/pages/Certificates.jsx
import React, { useState } from 'react';
import styles from './Certificates.module.css';

import cert1 from '../assets/cert1.png';
import cert2 from '../assets/cert2.png';
import cert3 from '../assets/cert3.png';
import cert4 from '../assets/cert4.png';

const certificates = [
  {
    title: 'Advanced Java Programming',
    issuer: 'MindLuster',
    date: 'January 2025',
    image: cert1,
    description: 'Focused on core and advanced Java concepts including OOP, exception handling, file I/O, and multithreading to build robust, scalable applications.',
  },
  {
    title: 'JavaScript Algorithms and Data Structures',
    issuer: 'FreeCodeCamp',
    date: 'May 2024',
    image: cert2,
    description: 'Learned problem-solving through JavaScript, covering algorithms, recursion, and data structures such as stacks, queues, linked lists, and trees.',
  },
  {
    title: 'Responsive Web Design',
    issuer: 'FreeCodeCamp',
    date: 'March 2024',
    image: cert3,
    description: 'Built responsive websites using HTML, CSS, and Flexbox/Grid, ensuring seamless user experiences across all devices and screen sizes.',
  },
  {
    title: 'Programming Fundamentals',
    issuer: 'Udacity',
    date: 'September 2024',
    image: cert4,
    description: 'Gained a strong foundation in programming logic, variables, conditionals, loops, and functions through hands-on Python-based learning.',
  },
];

export default function Certificates() {
  const [selectedCert, setSelectedCert] = useState(null);

  return (
    <section className={styles.container}>
      <h2 className={styles.heading}>My Certificates</h2>
      
      <div className={styles.grid}>
        {certificates.map((cert, index) => (
          <div
            key={index}
            className={styles.card}
            onClick={() => setSelectedCert(cert)}
            tabIndex={0}
            role="button"
            onKeyDown={(e) => { if (e.key === 'Enter') setSelectedCert(cert); }}
          >
            <img src={cert.image} alt={`${cert.title} Certificate`} className={styles.certImage} />
            <div className={styles.certInfo}>
              <h3>{cert.title}</h3>
              <p>{cert.issuer}</p>
              <p className={styles.date}>{cert.date}</p>
            </div>
          </div>
        ))}
      </div>

      {selectedCert && (
        <div
          className={styles.modal}
          onClick={() => setSelectedCert(null)}
          role="dialog"
          aria-modal="true"
        >
          <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
            <button
              className={styles.closeBtn}
              onClick={() => setSelectedCert(null)}
              aria-label="Close certificate view"
            >
              &times;
            </button>
            <img
              src={selectedCert.image}
              alt={`${selectedCert.title} Certificate Enlarged`}
              className={styles.modalImage}
            />
            <h3>{selectedCert.title}</h3>
            <p>{selectedCert.issuer}</p>
            <p className={styles.date}>{selectedCert.date}</p>
          </div>
        </div>
      )}
    </section>
  );
}
